// SubscriptionGate.tsx
import React, { useEffect, useState } from "react";
import { subscriptionAPI } from "../../../billing/utils/API";
import { SubscriptionOptions } from "./SubscriptionOptions";
import "./styles/SubscriptionGate.css";

interface Props {
  email: string;
  children: React.ReactNode; // content to show ONLY if user is paying
}

export const SubscriptionGate: React.FC<Props> = ({ email, children }) => {
  const [loading, setLoading] = useState(true);
  const [isPaying, setIsPaying] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;

    const fetchStatus = async () => {
      try {
        const status = await subscriptionAPI.getSubscriptionStatus(email);
        if (mounted) {
          setIsPaying(status.isPaying);
        }
      } catch (err: any) {
        console.error(err);
        if (mounted) setError("Failed to verify subscription status.");
      } finally {
        if (mounted) setLoading(false);
      }
    };

    if(email){
        fetchStatus();
    }
    
    return () => {
      mounted = false;
    };
  }, [email]);

  if (loading)
    return (
      <div className="subscription-gate__loading text-center">
        Checking subscription…
      </div>
    );

  if (error) {
    return (
      <div className="subscription-gate__error">
        <div className="subscription-gate__card">
          <h3 className="subscription-gate__title">Something went wrong</h3>
          <p className="subscription-gate__message">{error}</p>
        </div>
      </div>
    );
  }

  if (!isPaying) {
    return (
      <div className="subscription-gate__wrapper">
        <div className="subscription-gate__card">
          <h3 className="subscription-gate__title">Premium Feature</h3>

          <p className="subscription-gate__message">
            This feature is available only to subscribed users.
            Subscribe now to unlock all premium sustainability tools.
          </p>

          <div className="subscription-gate__actions">
            <SubscriptionOptions email={email} />
          </div>

          <p className="subscription-gate__helper">
            A subscription supports ongoing development and unlocks the full
            experience.
          </p>
        </div>
      </div>
    );
  }

  // User has subscription → render protected content
  return <>{children}</>;
};
